import React from "react";
import { css, useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";

type Props = {
    children: React.ReactNode,
    headerMenu: StandardPage,
    currentURLSegment?: string,
    selectedHeaderMenu?: StandardPage,
    selectedSegments?: string[],
    hasSubMenu: boolean,
    setSubMenu: Function,
    closeMenuHandler: Function,
    isBurgerMenuClick: boolean,
};

const BurgerNavHeaderMenuContainer: React.FC<Props> = ({
    children,
    headerMenu,
    currentURLSegment = "",
    selectedHeaderMenu = undefined,
    selectedSegments = undefined,
    hasSubMenu,
    setSubMenu,
    closeMenuHandler,
    isBurgerMenuClick,
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const setSubMenuHandler = () => {
        if (hasSubMenu) {
            setSubMenu({ headerMenu, keepHeader: true });
        } else if (headerMenu?.isClickable && currentURLSegment !== headerMenu?.uRLSegment) {
            navigate(headerMenu?.linkUrl);
            closeMenuHandler();
        }
    };

    const style = css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
        padding: 0 40px 0 62px;
        width: 100%;
        height: 56px;
        font-size: 20px;
        border-radius: ${hasSubMenu ? "25px 0 0 25px" : "25px"};
        color: ${theme.colours.white};
        cursor: pointer;
        
        // nav-menu-underline-tablet should be defined for the clicked menu only.
        ${selectedSegments?.includes(headerMenu?.uRLSegment) && css`
            .nav-menu-underline-tablet {
                margin-top: 3px;
                width: 100%;
                height: 4px;
                border-radius: 2px;
                background-color: ${isBurgerMenuClick ? theme.colours.curiousBlue : theme.colours.white};
            }
        `}
        
        ${(isBurgerMenuClick && headerMenu?.uRLSegment === selectedHeaderMenu?.uRLSegment) ? css`
            color: ${theme.colours.curiousBlue};
            background-color: white;
        ` : css`
            .nav-menu-underline-tablet {
                background-color: ${theme.colours.white};
            }
        `}
        
        ${headerMenu.uRLSegment !== selectedHeaderMenu?.uRLSegment && css`
            &:hover {
                div {
                    color: ${theme.colours.gold};

                    .nav-menu-underline-tablet {
                        background-color: ${theme.colours.gold};
                    }
                }
            }
        `}
    `;

    return (
        <div css={style} onClick={setSubMenuHandler}>
            {children}
        </div>
    );
};

export default BurgerNavHeaderMenuContainer;